<template>
  <div>
    <v-dialog v-model="mostra" width="400" persistent>
      <v-toolbar color="primary" dense class="white--text">
        <v-toolbar-title>Strumenti diagnostica</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small @click="chiudiDialog()"
          ><v-icon color="red">mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row style="display: block">
              <div v-if="strumenti_diagnostica != null">
                <v-list v-if="strumenti_diagnostica.length > 0" dense>
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, i) in strumenti_diagnostica"
                      :key="i"
                      :selectable="false"
                      inactive
                      style="pointer-events: none"
                    >
                      <v-list-item-icon>
                        <v-icon
                          style="pointer-events: all"
                          @click="GetFile(item)"
                          color="indigo"
                          class="icon"
                          >mdi-download-circle</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <p class="mt-5" v-else>Nessuno strumento di diagnostica disponibile per questo modulo</p> 
              </div>
              <p class="mt-5" v-else>Nessuno strumento di diagnostica disponibile per questo modulo</p>              
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import MimeType from "../.common/MimeTypes.js";
import { saveAs } from "file-saver";
export default {
  components: {
    SnackbarQV,
  },
  props: {},
  data: () => ({
    NETWORK: null,
    mostra: false,
    id_dispositivo: null,
    id_interfaccia: null,
    id_macchina: null,
    strumenti_diagnostica: [],
  }),
  watch: {
    strumenti_diagnostica: {
      immediate: true,
      handler() {
        //console.log(this.strumenti_diagnostica);
      },
    },
  },
  methods: {
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    chiudiDialog() {
      this.mostra = false;
      this.strumenti_diagnostica = [];
    },
    GetFile(item) {
      let that = this;
      const request = {
        controller: "quickconnext",
        endpoint : 'connext',
        response: { parse: false },
        showdialog: false,
        body: {
          action: "executediagnosticfunction",
          token: localStorage.user_token,
          id_dispositivo: this.id_dispositivo,
          interface_id: this.id_interfaccia,
          machine_id: this.id_macchina,
          function_id: parseInt(item.field),
        },
        method: "PUT",
        on: {
          load: function (response) {
            response = JSON.parse(response);
            let file_name = response.result_file_name;
            let content_type = MimeType.getMimeType(file_name.split(",")[1]);
            //e.log("response", response);
            let blob = that.b64toBlob(response.content, content_type);
            saveAs(blob, file_name);
          },
          error: function (err) {
            //console.log(err);
            that.$refs.SnackbarQV.print("error", err.srcElement.responseText);
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
  },
};
</script>
<style scoped>
.icon {
  transform: scale(1);
  transition: 0.25s;
}
.icon:hover {
  transform: scale(1.15);
  transition: 0.25s;
}
</style>
